// extracted by mini-css-extract-plugin
module.exports = {"container":"IndividualFormNominate_container__1NlZ_"};